import type { SxProps, Theme } from "@mui/material/styles";

const ACCENT_PURPLE = "#7B49C1";

export const getButtonSx = (isActive: boolean): SxProps<Theme> => ({
  position: "absolute",
  right: { xs: 42, sm: 52, md: 44 },
  top: "2px",
  bottom: "2px",
  height: "auto",
  transform: "none",
  zIndex: 2,
  minWidth: { xs: 48, sm: 64 },
  px: { xs: "5px", sm: "9px" },
  borderRadius: "999px",
  gap: { xs: "4px", sm: "6px" },
  backgroundColor: isActive
    ? "rgba(123, 73, 193, 0.12)"
    : "rgba(123, 73, 193, 0.06)",
  color: isActive ? ACCENT_PURPLE : "#7B49C1",
  "&:hover": {
    backgroundColor: isActive
      ? "rgba(123, 73, 193, 0.18)"
      : "rgba(123, 73, 193, 0.1)",
  },
  "&.Mui-disabled": {
    opacity: 0.45,
  },
  transition: "background-color 0.2s, color 0.2s",
});

export const buttonContentStyles: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "inherit",
  width: "100%",
  minWidth: 0,
};

export const leftSlotStyles: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 0,
  flex: 1,
};

export const personaNameStyles: SxProps = {
  fontSize: { xs: "10px", sm: "11px" },
  fontWeight: 600,
  lineHeight: 1.1,
  letterSpacing: "-0.2px",
  maxWidth: { xs: 44, sm: 56 },
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  userSelect: "none",
};

export const ccLettersStyles: SxProps = {
  fontSize: { xs: "10px", sm: "11px" },
  fontWeight: 700,
  lineHeight: 1,
  letterSpacing: { xs: "0.2px", sm: "0.5px" },
  userSelect: "none",
  flexShrink: 0,
};

export const avatarFallbackStyles: SxProps = {
  width: { xs: 14, sm: 18 },
  height: { xs: 14, sm: 18 },
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(123, 73, 193, 0.12)",
  color: ACCENT_PURPLE,
  flexShrink: 0,
  "& svg": {
    width: { xs: 10, sm: 12 },
    height: { xs: 10, sm: 12 },
  },
};
